
import { PersonalAccessToken } from "../Models/PersonalAccessToken";
import RespondClient from "../Models/RespondClient";
import { getApiHost } from "../util";
import { getInstance } from "./InstanceProvider";

export default class PersonalAccessTokenProvider {
    public personalAccessTokenProvider: PersonalAccessTokenProvider | undefined;

    public init() {
        if (!this.personalAccessTokenProvider) {
            this.personalAccessTokenProvider = new PersonalAccessTokenProvider();
        }
    }

    public create(name: string, isReadOnly: boolean): Promise<RespondClient<string>> {
        return getInstance().post(`${getApiHost()}/api/token`, {
            name,
            isReadOnly
        });
    }

    public list(): Promise<RespondClient<PersonalAccessToken[]>> {
        return getInstance().get(`${getApiHost()}/api/token/list`);
    }

    public revoke(tokenId: string): Promise<RespondClient<string>> {
        return getInstance().delete(`${getApiHost()}/api/token?tokenId=${tokenId}`);
    }
}

export const PersonalAccessTokenProviderInstance = new PersonalAccessTokenProvider();
